import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function ContentBody(props) {
  let className = `${style.content_body} ${props.className}`;
  return <div className={className}>{props.children} </div>;
}

ContentBody.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components to render on ContentBody
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

ContentBody.defaultProps = {
  className: '',
};
